import {
  AbstractCategory,
  AbstractCategoryWithSubcategories,
} from '../../data/types/categories';

export function buildCategoryTree(
  categories: AbstractCategory[],
): AbstractCategoryWithSubcategories[] {
  // Create a map to store categories by their id
  const categoryMap: { [key: number]: AbstractCategoryWithSubcategories } = {};

  // Initialize each category in the map and add sub_categories as an empty array
  categories.forEach((category) => {
    categoryMap[category.id] = { ...category, sub_categories: [] };
  });

  // Initialize an array to hold root-level categories
  const categoryTree: AbstractCategoryWithSubcategories[] = [];

  // Loop through the categories and build the tree structure
  categories.forEach((category) => {
    if (category.parent_category_id === 0) {
      // If no parent, it's a root category
      categoryTree.push(categoryMap[category.id]);
    } else {
      // If the category has a parent, add it as a subcategory of its parent
      const parentCategory = categoryMap[category.parent_category_id];
      if (parentCategory) {
        parentCategory.sub_categories.push(categoryMap[category.id]);
      }
    }
  });

  return categoryTree;
}
